import axios from 'axios';
import { getNonGwApiRoot } from '../../../constants/ParamountReactConstants';
import * as utils from '../../../utils/Utils';
import { BrandCustomData } from '../../../../types/brand_settings';

const CancelToken = axios.CancelToken;

let fetchBrandCustomDataCancelToken: (() => void) | undefined;

export function fetchBrandCustomData(brandId: number) {
  if (fetchBrandCustomDataCancelToken) fetchBrandCustomDataCancelToken();

  return {
    type: 'FETCH_BRAND_CUSTOM_DATA',
    payload: axios.get(`${getNonGwApiRoot()}/parents/owners/brands/${brandId}/custom_data`, {
      cancelToken: new CancelToken(c => {
        fetchBrandCustomDataCancelToken = c;
      }),
    }),
  };
}

export function updateBrandCustomData(brandId: number, customData: BrandCustomData[]) {
  const payload = {
    custom_data: customData,
  };

  return {
    type: 'UPDATE_BRAND_CUSTOM_DATA',
    payload: axios.patch(
      `${getNonGwApiRoot()}/parents/owners/brands/${brandId}/custom_data`,
      payload
    ),
  };
}

export function deleteBrandCustomData(brandId: number, customDataFieldId: number) {
  const params = utils.createURL([{ name: 'custom_data_field_id', values: customDataFieldId }]);

  return {
    type: 'DELETE_BRAND_CUSTOM_DATA',
    meta: { customDataFieldId },
    payload: axios.delete(
      `${getNonGwApiRoot()}/parents/owners/brands/${brandId}/custom_data${params}`
    ),
  };
}
